import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { AppDispatch, RootState } from '../redux-stores/store';
import { fetchCollaboration } from '../redux-stores/slices/collaborationDetailsSlice';
import { useSelector } from 'react-redux';
import { formatMediaTypes } from '../utils/helpers';
import { Link } from 'react-router-dom';
import { Milestone } from '../types/collaborations/CollaborationTypes';
import HTMLContent from '../components/HTMLContent';
import { setHeader } from '../redux-stores/slices/layoutSlice';
import { defaultAppHeaderProps } from '../types/layout/layoutTypes';

const CollaborationMilestones: React.FC = () => {

    const dispatch: AppDispatch = useDispatch();
    const { campaignId } = useParams();
    const navigate = useNavigate();

    const collaborationData = useSelector((state: RootState) => state.collaborationDetails.collaborations[campaignId!]?.collaborationData);
    const collaboration = collaborationData?.collaboration ?? null;
    const milestones = collaborationData?.milestones ?? [];

    const fetchCollaborationData = useCallback(async (force = false) => {
        if (campaignId)
            await dispatch(fetchCollaboration({ campaignId, force }))
    }, [dispatch, campaignId])

    useEffect(() => {
        if (campaignId) {
            fetchCollaborationData();
        }
    }, [campaignId, fetchCollaborationData])

    const completedMilestones = useMemo(() => {
        return milestones.filter((milestone) => milestone.ended_at)
    }, [milestones])

    const incompleteMilestones = useMemo(() => {
        return milestones.filter((milestone) => !milestone.ended_at)
    }, [milestones])

    const getMilestoneName = (milestone: Milestone) => {
        return <>{milestones.length > 1 ? `#${milestone.sort_order} ` : ''}{milestone.gig_type.name}</>
    }


    useEffect(() => {
        if (collaboration?.campaign?.name) {
            dispatch(setHeader({
                generic: false,
                page: {
                    title: collaboration?.campaign?.name,
                    onBackClick: () => navigate(`/collaborations`)
                }
            }))
        }

        return () => {
            dispatch(setHeader(defaultAppHeaderProps))
        }

    }, [collaboration])

    return (
        <div className='app-page position-relative'>
            {/* <div className="campaign-bg-card"></div>
            <div className="campaign-data">
                <h6 className='text-truncate pb-1'>{collaboration?.campaign?.name}</h6>
                {
                    (collaboration?.campaign?.brand) &&
                    <span>{collaboration?.campaign?.brand?.name}</span>
                }
            </div> */}
            <div className="milestone-cards p-0">
                {
                    incompleteMilestones.map((milestone, i) => {
                        return (
                            <div className="milestone-card app-card" key={i}>
                                <div className="milestone-data">
                                    <h6 className={`m-0 ${!milestone.is_active ? 'inactive' : ''}`}>{getMilestoneName(milestone)}</h6>
                                    <span>{formatMediaTypes(milestone.content_media_types)}</span>
                                </div>
                                {
                                    milestone.is_active &&
                                    <React.Fragment>
                                        {
                                            milestone.brief &&
                                            <span className='milestone-brief fs-14 text-dark-gray fw-400'>
                                                <HTMLContent content={milestone.brief && milestone.brief.length > 200
                                                    ? `${milestone.brief.slice(0, 200)}...`
                                                    : milestone.brief} />
                                            </span>
                                        }
                                        <Link to={{ pathname: `/collaborations/${campaignId}/milestone/${milestone.id}` }} className="btn btn-primary mt-3 w-100">
                                            {milestone.starts_at ? "Continue" : "Start"} working on {getMilestoneName(milestone)}
                                        </Link>
                                    </React.Fragment>
                                }
                            </div>
                        )
                    })
                }
            </div>

            {
                completedMilestones.length > 0 &&
                <div className="completed-milestones m-0 p-0">
                    <span className='text-primary fw-500 fs-12 text-uppercase'>Completed</span>
                    <div className="d-flex flex-column gap-3">
                        {
                            completedMilestones.map((milestone, i) => {
                                return (
                                    <div className="app-card cursor-pointer" onClick={() => navigate({ pathname: `/collaborations/${campaignId}/milestone/${milestone.id}` })} key={i}>
                                        <div className="milestone-data">
                                            <h6 className={`m-0`}>{getMilestoneName(milestone)}</h6>
                                            <span>{formatMediaTypes(milestone.content_media_types)}</span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            }

        </div>
    )
}

export default CollaborationMilestones